import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [
    "newLogoContainer",
    "newLogoField",
    "addLogoButton",
    "removeLogoButton",
  ];

  showNewLogoFields(event) {
    event.preventDefault();
    this.newLogoContainerTarget.classList.remove("hidden");
    this.newLogoFieldTargets.forEach((element) => (element.disabled = false));
    this.addLogoButtonTarget.classList.add("hidden");
    this.removeLogoButtonTarget.classList.remove("hidden");
  }

  hideNewLogoFields(event) {
    event.preventDefault();
    this.newLogoContainerTarget.classList.add("hidden");
    this.newLogoFieldTargets.forEach((element) => {
      element.disabled = true;
      element.value = "";
    });
    this.addLogoButtonTarget.classList.remove("hidden");
    this.removeLogoButtonTarget.classList.add("hidden");
  }
}
